(() => {
  let cleanup = () => {};
  function initialize() {
    cleanup();
    const abort = new AbortController();
    const signal = abort.signal;
    const on = (el, event, fn, options = {}) => el?.addEventListener(event, fn, { ...options, signal });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const menu = document.querySelector('.menu');
    const header = document.querySelector('header');
    const closeMenu = () => { menu?.setAttribute('aria-expanded', 'false'); menu?.setAttribute('aria-label', 'Open navigation'); header?.classList.remove('open'); };
    on(menu, 'click', () => { const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', open); menu.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation'); header?.classList.toggle('open', open); });
    document.querySelectorAll('nav a').forEach(a => on(a, 'click', closeMenu));
    const film = document.querySelector('#hero-video');
    const filmButton = document.querySelector('.motion-toggle');
    let userPaused = false;
    const syncFilm = () => { if (!film || !filmButton) return; const playing = !film.paused; filmButton.classList.toggle('is-playing', playing); filmButton.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video'); filmButton.querySelector('span').textContent = playing ? 'Pause film' : 'Play film'; };
    const playFilm = async () => { if (!film) return; if (!film.src) film.src = film.dataset.src; film.muted = true; try { await film.play(); } catch { syncFilm(); } };
    if (film && filmButton) {
      filmButton.hidden = false;
      on(film, 'playing', () => { film.classList.add('is-ready'); syncFilm(); });
      on(film, 'pause', syncFilm);
      on(film, 'error', () => { film.classList.remove('is-ready'); filmButton.hidden = true; });
      on(filmButton, 'click', () => { if (film.paused) { userPaused = false; playFilm(); } else { userPaused = true; film.pause(); } });
      on(reduced, 'change', e => { if (e.matches) film.pause(); else if (!userPaused) playFilm(); });
      if (!reduced.matches && !navigator.connection?.saveData) playFilm();
    }
    const tabs = [...document.querySelectorAll('[data-step]')];
    const method = document.querySelector('.method');
    const methodSticky = method?.querySelector('.method-sticky');
    let activeStep = -1;
    function setStep(index) {
      const step = tabs[index]; if (!step) return;
      activeStep = index;
      document.querySelector('#method-label').textContent = step.textContent.trim().toUpperCase();
      document.querySelector('#method-title').textContent = step.dataset.title;
      document.querySelector('#method-description').textContent = step.dataset.description;
      tabs.forEach((b, i) => { b.setAttribute('aria-selected', i === index); b.tabIndex = i === index ? 0 : -1; });
      const panel = document.querySelector('#method-panel'); panel.textContent = step.dataset.title + ' ' + step.dataset.description; panel.setAttribute('aria-labelledby', step.id);
    }
    const keyboardTabs = (items, select) => items.forEach((b, i) => on(b, 'keydown', e => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault(); const n = e.key === 'Home' ? 0 : e.key === 'End' ? items.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
      items[n].focus({ preventScroll: true }); select(n);
    }));
    const methodScrollDistance = () => {
      if (!method || !methodSticky || !tabs.length || reduced.matches || window.Shopify?.designMode) return 0;
      if (getComputedStyle(methodSticky).position !== 'sticky') return 0;
      return Math.max(0, method.offsetHeight - methodSticky.offsetHeight);
    };
    const selectMethodStep = index => {
      if (!tabs[index] || index === activeStep) return;
      setStep(index);
      const distance = methodScrollDistance();
      if (!distance) return;
      // Match the scroll position to the chosen step so the next scroll continues from it.
      const sectionTop = window.scrollY + method.getBoundingClientRect().top;
      const progress = (index + 0.5) / tabs.length;
      window.scrollTo({ top: sectionTop + distance * progress, behavior: 'instant' });
    };
    tabs.forEach((b, i) => on(b, 'click', () => selectMethodStep(i)));
    keyboardTabs(tabs, selectMethodStep); setStep(0);
    const orbit = document.querySelector('.orbit');
    const tabContainer = document.querySelector('.method-tabs');
    const alignIcons = () => {
      if (!orbit || !tabContainer) return;
      const r = orbit.getBoundingClientRect(), tr = tabContainer.getBoundingClientRect(), radius = r.width / 2;
      if (!radius) return;
      tabs.forEach(b => { const br = b.getBoundingClientRect(), icon = b.querySelector('i'), dx = br.left + br.width / 2 - (r.left + radius); b.style.top = (r.top + radius - Math.sqrt(Math.max(0, radius * radius - dx * dx)) - tr.top - icon.offsetHeight / 2) + 'px'; });
    };
    const observer = new ResizeObserver(alignIcons);
    if (orbit && tabContainer) { observer.observe(orbit); observer.observe(tabContainer); alignIcons(); document.fonts.ready.then(() => { if (!signal.aborted) alignIcons(); }); }
    let methodFrame = 0;
    const updateMethod = () => {
      methodFrame = 0;
      if (signal.aborted) return;
      // Use the same pinned-panel boundary for clicks and scrolling.
      const distance = methodScrollDistance();
      if (!distance) return;
      const progress = Math.max(0, Math.min(1, -method.getBoundingClientRect().top / distance));
      const index = Math.min(tabs.length - 1, Math.floor(progress * tabs.length));
      if (index !== activeStep) setStep(index);
    };
    const queueMethod = () => { if (!methodFrame) methodFrame = requestAnimationFrame(updateMethod); };
    const configureMethod = () => {
      method?.classList.toggle('is-scroll-driven', !reduced.matches && !window.Shopify?.designMode);
      alignIcons();
      queueMethod();
    };
    on(window, 'scroll', queueMethod, { passive: true });
    on(window, 'resize', configureMethod, { passive: true });
    on(reduced, 'change', configureMethod);
    configureMethod();
    const plans = [...document.querySelectorAll('[data-engagement]')];
    function setPlan(index) {
      const current = plans[index]; if (!current) return;
      plans.forEach((b, i) => { b.setAttribute('aria-selected', i === index); b.tabIndex = i === index ? 0 : -1; });
      document.querySelectorAll('[data-plan]').forEach(p => p.hidden = p.dataset.plan !== current.dataset.engagement);
      document.querySelector('#engagement-panel')?.setAttribute('aria-labelledby', current.id);
    }
    plans.forEach((b, i) => on(b, 'click', () => setPlan(i))); keyboardTabs(plans, setPlan); setPlan(0);
    const dialog = document.querySelector('#project-dialog');
    if (dialog) {
      document.querySelectorAll('[data-project]').forEach(card => on(card, 'click', () => {
        const body = dialog.querySelector('.dialog-body'); body.replaceChildren();
        const image = card.querySelector('img')?.cloneNode(true); if (image) { image.removeAttribute('loading'); body.append(image); }
        body.append(card.querySelector('.project-template').content.cloneNode(true));
        dialog.showModal(); document.body.classList.add('dialog-open');
      }));
      on(dialog.querySelector('.dialog-close'), 'click', () => dialog.close());
      on(dialog, 'close', () => document.body.classList.remove('dialog-open'));
      on(dialog, 'click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); });
    }
    const railObservers = [];
    document.querySelectorAll('.project-rail').forEach(rail => {
      const section = rail.closest('section');
      const controls = section.querySelector('[data-rail-controls]');
      const prev = section.querySelector('[data-rail="prev"]');
      const next = section.querySelector('[data-rail="next"]');
      const syncRail = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        if (controls) controls.hidden = max <= 2;
        if (prev) prev.disabled = max <= 2 || rail.scrollLeft <= 2;
        if (next) next.disabled = max <= 2 || rail.scrollLeft >= max - 2;
      };
      [prev, next].forEach(button => on(button, 'click', () => {
        const card = rail.querySelector('.project-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({left: (button === next ? 1 : -1) * (card.getBoundingClientRect().width + gap), behavior: reduced.matches ? 'instant' : 'smooth'});
      }));
      on(rail, 'scroll', syncRail, {passive: true});
      const resize = new ResizeObserver(syncRail);
      resize.observe(rail);
      rail.querySelectorAll('.project-card').forEach(card => resize.observe(card));
      railObservers.push(resize);
      syncRail();
      document.fonts.ready.then(() => { if (!signal.aborted) syncRail(); });
    });
    on(document, 'click', e => {
      const link = e.target.closest('a[href^="#"]'); if (!link || link.hash.length < 2) return;
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1))); if (!target) return;
      e.preventDefault(); if (dialog?.open) dialog.close(); closeMenu();
      history.pushState(null, '', link.hash);
      if (target.id === 'contact') target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
    });
    on(document, 'shopify:block:select', e => {
      const step = e.target.closest('[data-step]'); if (step) setStep(tabs.indexOf(step));
      const plan = e.target.closest('[data-plan]'); if (plan) setPlan(plans.findIndex(b => b.dataset.engagement === plan.dataset.plan));
      const question = e.target.closest('details'); if (question) question.open = true;
    });
    cleanup = () => { abort.abort(); observer.disconnect(); railObservers.forEach(o => o.disconnect()); cancelAnimationFrame(methodFrame); };
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
  document.addEventListener('shopify:section:reorder', initialize);
})();
